'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_pages_RecipeListPage$State(recipes, recipeCount_$_lo, recipeCount_$_hi, columns, search, cuisines, confirmContent, dialog, scheduleDialogOptions, onConfirm) {
  this.jh = null;
  this.iU = 0;
  this.iV = 0;
  this.eJ = null;
  this.fv = null;
  this.jf = null;
  this.kO = null;
  this.kP = null;
  this.k8 = null;
  this.jg = null;
  this.jh = recipes;
  this.iU = recipeCount_$_lo;
  this.iV = recipeCount_$_hi;
  this.eJ = columns;
  this.fv = search;
  this.jf = cuisines;
  this.kO = confirmContent;
  this.kP = dialog;
  this.k8 = scheduleDialogOptions;
  this.jg = onConfirm;
}
export { $c_Lmealorama_pages_RecipeListPage$State as $c_Lmealorama_pages_RecipeListPage$State };
$p = $c_Lmealorama_pages_RecipeListPage$State.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_pages_RecipeListPage$State;
/** @constructor */
function $h_Lmealorama_pages_RecipeListPage$State() {
}
export { $h_Lmealorama_pages_RecipeListPage$State as $h_Lmealorama_pages_RecipeListPage$State };
$h_Lmealorama_pages_RecipeListPage$State.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, 80204913);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.jh));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().xT(this.iU, this.iV));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.eJ));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.fv));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.jf));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.kO));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.kP));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.k8));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Ljapgolly_scalajs_react_callback_CallbackTo(this.jg)));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 9);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_pages_RecipeListPage$State)) {
    var x_$_lo = this.iU;
    var x_$_hi = this.iV;
    var $x_8 = x$0;
    var x$1_$_lo = $x_8.iU;
    var x$1_$_hi = $x_8.iV;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2 = this.jh;
      var x$2$1 = x$0.jh;
      var $x_7 = ((x$2 === null) ? (x$2$1 === null) : x$2.f(x$2$1));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$3 = this.eJ;
      var x$4 = x$0.eJ;
      var $x_6 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$5 = this.fv;
      var x$6 = x$0.fv;
      var $x_5 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$7 = this.jf;
      var x$8 = x$0.jf;
      var $x_4 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$9 = this.kO;
      var x$10 = x$0.kO;
      var $x_3 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$11 = this.kP;
      var x$12 = x$0.kP;
      var $x_2 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$13 = this.k8;
      var x$14 = x$0.k8;
      var $x_1 = ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$15 = this.jg;
      var x$16 = x$0.jg;
      return ((x$15 === null) ? (x$16 === null) : (x$15 === x$16));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 9;
});
$p.r = (function() {
  return "State";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.jh;
      break;
    }
    case 1: {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.iU, this.iV);
      break;
    }
    case 2: {
      return this.eJ;
      break;
    }
    case 3: {
      return this.fv;
      break;
    }
    case 4: {
      return this.jf;
      break;
    }
    case 5: {
      return this.kO;
      break;
    }
    case 6: {
      return this.kP;
      break;
    }
    case 7: {
      return this.k8;
      break;
    }
    case 8: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Ljapgolly_scalajs_react_callback_CallbackTo(this.jg);
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_pages_RecipeListPage$State(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kD)));
}
export { $isArrayOf_Lmealorama_pages_RecipeListPage$State as $isArrayOf_Lmealorama_pages_RecipeListPage$State };
var $d_Lmealorama_pages_RecipeListPage$State = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_pages_RecipeListPage$State, "mealorama.pages.RecipeListPage$State", ({
  kD: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_pages_RecipeListPage$State as $d_Lmealorama_pages_RecipeListPage$State };
//# sourceMappingURL=mealorama.pages.-Recipe-List-Page$-State.js.map
